<script setup lang="ts">
import type { BreadcrumbListItem } from 'types';

defineProps<{
  breadcrumbs: BreadcrumbListItem[];
  currentPage: string;
}>();
</script>

<template>
  <nav
    v-if="breadcrumbs.length"
    aria-labelledby="breadcrumb-list"
    class="breadcrumb container overflow-x-clip py-4 md:overflow-x-visible"
  >
    <ul
      id="breadcrumb-list"
      :aria-label="$t('Aria.Global.Breadcrumbs')"
      class="z-index-1 flex w-full flex-wrap gap-1 break-words"
    >
      <li
        v-for="breadcrumb in breadcrumbs"
        :key="breadcrumb.name"
        class="list-style-none flex items-center"
      >
        <BaseLink
          class="!inline-block max-w-[50vw] overflow-x-clip text-ellipsis whitespace-nowrap text-sm"
          :to="breadcrumb.url"
          :title="breadcrumb.name"
        >
          {{ breadcrumb.name }}
        </BaseLink>
        <BaseIcon
          name="chevron-right"
          aria-hidden="true"
          focusable="false"
          prefix="arrows"
          class="relative top-px text-h4"
          size="20px"
        />
      </li>
      <li
        class="list-style-none flex items-center"
        aria-current="page"
      >
        <span class="!inline-block max-w-[50vw] overflow-x-clip text-ellipsis whitespace-nowrap text-sm">
          {{ currentPage }}
        </span>
      </li>
    </ul>
  </nav>
</template>
